import { ApiService } from "./ApiService";
import { InvoiceDto } from "@shared/types/InvoiceDto";
import { GetInvoiceResponse } from "@shared/types/payloads/GetInvoiceResponse";

export interface PaymentStatusResponse {
  invoiceId: string;
  status: string;
  isPaid: boolean;
  paidAt: string | null;
  amount: number;
  currency: string;
}

export class InvoiceService {
  constructor(private readonly apiService: ApiService) {}

  async getInvoices(): Promise<InvoiceDto[]> {
    return this.apiService.request<InvoiceDto[]>("/invoices/list", {
      method: "GET",
      requireAuth: true,
    });
  }

  async getInvoiceUrl(invoiceId: string): Promise<GetInvoiceResponse> {
    return this.apiService.request<GetInvoiceResponse>(
      `/invoices/${invoiceId}`,
      {
        method: "GET",
        requireAuth: true,
      }
    );
  }

  async getPaymentStatus(invoiceId: string): Promise<PaymentStatusResponse> {
    return this.apiService.request<PaymentStatusResponse>(
      `/invoices/${invoiceId}/paymentStatus`,
      {
        method: "GET",
        requireAuth: true,
      }
    );
  }
}
